import { useCallback } from "react"
import { OffStatus, OnStatus, WeakConnectStatus } from "../Icons/Icons"

function RenderStatus({ status, companyCode }) {
    const renderStatus = useCallback((statusCode, companyCode) => {
        if (companyCode === 'DEFAULT') {
            const status = statusCode === 0 ? <OnStatus /> :
                statusCode === 1 ? <WeakConnectStatus /> :
                    statusCode === 2 ? <WeakConnectStatus /> :
                        <OffStatus />
            return status
        } else {
            const status = statusCode === 0 ? <OnStatus /> : <OffStatus />
            return status
        }
    }, [])

    return (
        <>
            {renderStatus(status, companyCode)}
        </>
    )
}

export default RenderStatus;